import { TeamT } from 'types'
import { getTeamNameByLanguage } from 'types/utils'

export const getFullTeamLabel = (team: TeamT, language: string, isMultiTenant: boolean, separator = '|') => {
  const teamName = getTeamNameByLanguage(team, language)
  if (!isMultiTenant) return teamName
  if (team.tenant) return `${team.tenant.name} ${separator} ${teamName}`
  return `${team.owner?.name} ${separator} ${teamName}`
}
